import './App.css';
import './index.css';
import Portfolio from "./Portforlio";

function App() {
    return (
        <>
            <Portfolio />
        </>
    );
}

      export default App;
